import { api } from './api';
import { SEARCH_SERVICE_ENDPOINT } from '../../utils/environment-variables';

export interface ISearchRequest {
    query?: string;
    filters?: SearchFilters;
    sort?: { [x: string]: string }[];
    pagination?: {
        from: number;
        size: number;
    };
}

export interface SearchFilters {
    invitedAt?: {
        from?: string;
        to?: string;
    };
    reportGeneratedAt?: {
        from?: string;
        to?: string;
    };
}

export interface ISearchAPIResponse {
    items: ISearchAPIResponseContext[] | [];
    total: number;
}

export interface ISearchResponse {
    items: ISearchResponseContext[] | [];
    total: number;
}

export interface ISearchAPIResponseContext {
    _index: string;
    _id: string;
    _score: unknown;
    _source: {
        invited_at: string;
        company_id: string;
        company_slug: string;
        group_id: string;
        invitation_id: string;
        user_id: string;
        email: string;
        first_name: string;
        last_name: string;
        scan_template_id: string;
        is_active: boolean;
        report_id?: string;
        report_generated_at?: string;
    };
}

export interface ISearchResponseContext {
    invitedAt: string;
    companyId: string;
    companySlug: string;
    groupId: string;
    invitationId: string;
    userId: string;
    email: string;
    firstName: string;
    lastName: string;
    scanTemplateId: string;
    isActive: boolean;
    reportId?: string;
    reportGeneratedAt?: string;
}

export interface SearchedParticipant {
    user_id: string;
    invitation_id: string;
    first_name: string;
    last_name: string;
    email: string;
    invited_at: string;
    user_registered_at: string;
    company_id: string;
    company_slug: string;
    company_name: string;
    group_id: string;
    group_name: string;
    has_opt_out_questionnaire: boolean;
    scan_template_id: string;
    is_active: boolean;
    report_id?: string;
    report_generated_at?: string;
}

export const search = api.injectEndpoints({
    endpoints: (builder) => ({
        searchRequest: builder.query<
            ISearchResponse,
            {
                searchRequestData: ISearchRequest;
                companyId?: string;
                groupId?: string;
            }
        >({
            query: ({ companyId, groupId, searchRequestData }) => ({
                url: `${SEARCH_SERVICE_ENDPOINT}/search/participants`,
                method: 'POST',
                body: {
                    ...searchRequestData,
                    company_id: companyId,
                    group_id: groupId,
                },
            }),
            transformResponse: (
                response: ISearchAPIResponse,
            ): ISearchResponse => {
                const items: ISearchResponseContext[] = response.items.map(
                    (item: ISearchAPIResponseContext) => {
                        const source = item._source;
                        return {
                            invitedAt: source.invited_at,
                            companyId: source.company_id,
                            companySlug: source.company_slug,
                            groupId: source.group_id,
                            scanTemplateId: source.scan_template_id,
                            isActive: source.is_active,
                            invitationId: source.invitation_id,
                            userId: source.user_id,
                            email: source.email,
                            firstName: source.first_name,
                            lastName: source.last_name,
                            reportId: source.report_id,
                            reportGeneratedAt: source.report_generated_at,
                        };
                    },
                );

                return {
                    items,
                    total: response.total,
                };
            },
        }),
    }),
});

export const {
    useSearchRequestQuery,
    util: { getRunningQueriesThunk },
} = search;

// Export the API slice for use in SSR (if needed)
// export const { getSearch } = search.endpoints;
